module.exports = __webpack_public_path__ + "img/noah_logo.b8663ae8.png";